import React from "react";
import p1 from "../../assets/p1.png";
import p2 from "../../assets/p2.png";
import p3 from "../../assets/p3.png";
import p4 from "../../assets/p4.png";

import "./partners.css";

const Partners = () => {
  const partnerLogos = [
    { id: 1, src: p1, alt: "IronNode" },
    { id: 3, src: p3, alt: "DAS" },
    { id: 2, src: p2, alt: "Türkiye Rust Community" },
    { id: 4, src: p4, alt: "Solana Superteam Balkan" },


  ];

  return (
    <section className="partners">
      <div className="partners-header">
        <h1>Partners</h1>
      </div>

      <div className="partners-carousel">
        <button className="nav-button prev">←</button>

        <div className="partners-container">
          {partnerLogos.map((partner) => (
            <div key={partner.id} className="partner-logo">
              <img
                src={partner.src}
                alt={partner.alt}
                // Beyaz olan DAS logosunu görünürlük için siyah göster
                style={{
                  ...(partner.id === 3
                    ? {
                        filter: "grayscale(100%) brightness(0)",
                      }
                    : {}),
                }}
              />
            </div>
          ))}
        </div>

        <button className="nav-button next">→</button>
      </div>
    </section>
  );
};

export default Partners;
